<template>
  <div class="page-wrapper">
    <!-- ===================== PC 版（折叠搜索栏） ===================== -->
    <div class="pc-version">
      <div
        class="user-coupon-table-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- PC 搜索栏（折叠版） -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <div class="search-collapse-btn" @click="toggleSearch">
            <i
              class="el-icon-arrow-down"
              :class="{ 'el-icon-arrow-up': !searchCollapsed }"
            ></i>
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </div>
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              gap: '10px',
              alignItems: 'center',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              style="width: 160px"
              clearable
            ></el-input>

            <el-select
              v-model="searchParams.status"
              placeholder="优惠券状态"
              clearable
              style="width: 160px"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.status"
                :label="item.desc"
                :value="item.status"
              ></el-option>
            </el-select>

            <el-select
              v-model="searchParams.type"
              placeholder="优惠券类型"
              clearable
              style="width: 160px"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              ></el-option>
            </el-select>
          </div>
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </div>
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
          />
          <el-table-column label="优惠券名称" prop="name" min-width="180" />
          <el-table-column
            label="优惠券类型"
            prop="type_desc"
            width="140"
            align="center"
          />

          <el-table-column label="优惠券状态" width="120" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.status === 1
                    ? 'success'
                    : scope.row.status === 2
                    ? 'info'
                    : 'danger'
                "
              >
                {{ scope.row.status_desc }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            label="面额"
            prop="amount"
            width="100"
            align="center"
          />
          <el-table-column
            label="最低消费"
            prop="min_amount"
            width="120"
            align="center"
          />
          <el-table-column label="过期时间" prop="expired_at" width="180" />
          <el-table-column label="创建时间" prop="created_at" width="180" />
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <el-dialog
          title="优惠券详情"
          :visible.sync="detailVisible"
          width="600px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="用户ID"
              ><span>{{ detailForm.user_id }}</span></el-form-item
            >
            <el-form-item label="优惠券ID"
              ><span>{{ detailForm.coupon_id }}</span></el-form-item
            >
            <el-form-item label="优惠券名称"
              ><span>{{ detailForm.name }}</span></el-form-item
            >
            <el-form-item label="优惠券类型"
              ><span>{{ detailForm.type_desc }}</span></el-form-item
            >
            <el-form-item label="优惠券状态"
              ><span>{{ detailForm.status_desc }}</span></el-form-item
            >
            <el-form-item label="面额"
              ><span>{{ detailForm.amount }} 元</span></el-form-item
            >
            <el-form-item label="最低消费"
              ><span>{{ detailForm.min_amount }} 元</span></el-form-item
            >
            <el-form-item label="来源备注"
              ><span>{{ detailForm.remark || "-" }}</span></el-form-item
            >
            <el-form-item label="过期时间"
              ><span>{{ detailForm.expired_at }}</span></el-form-item
            >
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ detailForm.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ===================== 移动端（折叠搜索栏） ===================== -->
    <div class="mobile-version">
      <div
        class="mobile-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 移动端搜索栏（折叠版） -->
        <div class="mobile-search">
          <div class="mobile-search-collapse" @click="toggleSearch">
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </div>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            ></el-input>
            <el-select
              v-model="searchParams.status"
              placeholder="优惠券状态"
              clearable
              size="medium"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.status"
                :label="item.desc"
                :value="item.status"
              ></el-option>
            </el-select>
            <el-select
              v-model="searchParams.type"
              placeholder="优惠券类型"
              clearable
              size="medium"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              ></el-option>
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              style="flex: 1"
              @click="getList"
              >搜索</el-button
            >
            <el-button plain round style="flex: 1" @click="resetSearch"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleRowClickMobile(item)"
          >
            <div class="card-top">
              <div class="label">{{ item.name }}</div>
              <el-tag
                :type="
                  item.status === 1
                    ? 'success'
                    : item.status === 2
                    ? 'info'
                    : 'danger'
                "
                size="mini"
              >
                {{ item.status_desc }}
              </el-tag>
            </div>
            <div class="card-body">
              <div><span>用户ID：</span>{{ item.user_id }}</div>
              <div><span>类型：</span>{{ item.type_desc }}</div>
              <div><span>面额：</span>{{ item.amount }} 元</div>
              <div><span>最低消费：</span>{{ item.min_amount }} 元</div>
              <div><span>过期时间：</span>{{ item.expired_at }}</div>
            </div>
            <div class="card-footer">
              <div>创建：{{ item.created_at }}</div>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="prev, pager, next, total"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <el-dialog
          title="优惠券详情"
          :visible.sync="detailVisibleMobile"
          width="90%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form :model="detailForm" label-width="100px" size="small">
            <el-form-item label="ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="用户ID"
              ><span>{{ detailForm.user_id }}</span></el-form-item
            >
            <el-form-item label="优惠券名称"
              ><span>{{ detailForm.name }}</span></el-form-item
            >
            <el-form-item label="类型"
              ><span>{{ detailForm.type_desc }}</span></el-form-item
            >
            <el-form-item label="状态"
              ><span>{{ detailForm.status_desc }}</span></el-form-item
            >
            <el-form-item label="面额"
              ><span>{{ detailForm.amount }} 元</span></el-form-item
            >
            <el-form-item label="最低消费"
              ><span>{{ detailForm.min_amount }} 元</span></el-form-item
            >
            <el-form-item label="过期时间"
              ><span>{{ detailForm.expired_at }}</span></el-form-item
            >
            <el-form-item label="备注"
              ><span>{{ detailForm.remark || "-" }}</span></el-form-item
            >
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisibleMobile = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "UserCouponList",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      // 搜索参数
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        status: "",
        type: "",
      },
      // 下拉选项
      statusOptions: [],
      typeOptions: [],
      // 弹窗
      detailVisible: false,
      detailVisibleMobile: false,
      detailForm: {},
      // 搜索折叠
      searchCollapsed: true,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取优惠券列表
    async getList() {
      this.loading = true;
      try {
        const res = await api.users.userCouponList({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
          this.statusOptions = res.data.data.status || [];
          this.typeOptions = res.data.data.type || [];

          // 给每一项自动加上状态描述
          this.tableData = this.tableData.map((item) => {
            const statusItem = this.statusOptions.find(
              (s) => s.status === item.status
            );
            item.status_desc = statusItem ? statusItem.desc : "未知";
            return item;
          });
        }
      } finally {
        this.loading = false;
      }
    },

    // PC 点击行查看详情
    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },

    // 移动端点击查看详情
    handleRowClickMobile(row) {
      this.detailForm = { ...row };
      this.detailVisibleMobile = true;
    },

    // 重置搜索
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        status: "",
        type: "",
      };
      this.getList();
    },

    // 每页条数改变
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },

    // 页码改变
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },

    // 折叠/展开搜索栏
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
.user-coupon-table-container {
  padding: 20px;
}
.mobile-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.card-top .label {
  font-size: 15px;
  font-weight: 500;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
.card-body span {
  color: #999;
}
.card-footer {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/userCoupon.vue